import { GetterTree } from 'vuex'
import { ISearchState, ILookupResult } from './types'

const getters: GetterTree<ISearchState, any> = {
  lookup(state): string {
    return state.lookup
  },
  results(state): ILookupResult[][] {
    return state.results
  },
  accessToken(state): string {
    return state.accessToken
  },
  fundSearchApiEndpoint(state): string {
    return state.fundSearchApiEndpoint
  },
  selectedResultIndex(state): number {
    return state.selectedResultIndex
  },
  selectedResult(state): ILookupResult | null {
    const results = state.results
    if (results.length <= 0) return null
    let groupIndex = 0
    let index = state.selectedResultIndex
    while (results.length > 0 && groupIndex < results.length && results[groupIndex].length < index) {
      index = index - results[groupIndex].length
      groupIndex = groupIndex + 1
    }
    const selectedGroup = results[groupIndex]
    return selectedGroup[index]
  },
  canResultPanelOpen(state): boolean {
    return state.canResultPanelOpen
  },
  cacheSuffix(state): string {
    return state.cacheSuffix
  },
  mustHaveCacheSuffix(state): boolean {
    return state.mustHaveCacheSuffix;
  }, 
}

export default getters

